import { Avatar, Box, Link as MuiLink, Stack, Typography } from '@mui/material';
import { ArrowSquareOutIcon } from '@phosphor-icons/react';

// Same env-driven Hub URL already used in SettingsDrawer.tsx's "Connect a
// custom domain" link — not a guessed path.
const HUB_URL = (import.meta.env.VITE_HUB_URL ?? 'https://scoutingops.com') as string;

interface LogoSectionProps {
  logoUrl: string | null;
  unitName: string;
}

// Read-only, matching Scouting Ops Hub's Website > Style > Logo section —
// the logo is the org's own Clerk logo, always kept in sync into
// sites.logo_url (see use-site.ts) since the anonymous public site can't
// read organization.imageUrl directly. Editing happens in one place
// (Clerk's org profile, via Hub), not duplicated here as a second,
// independently-diverging URL field.
export function LogoSection({ logoUrl, unitName }: LogoSectionProps) {
  return (
    <Box>
      <Typography variant="overline" color="text.secondary" sx={{ fontWeight: 700, display: 'block', mb: 1 }}>
        Logo
      </Typography>
      <Stack direction="row" spacing={2} sx={{ alignItems: 'center' }}>
        <Avatar src={logoUrl ?? undefined} sx={{ height: 56, width: 56 }} variant="rounded">
          {unitName[0]}
        </Avatar>
        <Stack spacing={0.5}>
          <Typography variant="body2" color="text.secondary">
            Your website uses your organization&apos;s logo.
          </Typography>
          <MuiLink
            href={`${HUB_URL}/unit`}
            target="_blank"
            rel="noopener noreferrer"
            variant="body2"
            sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5, alignSelf: 'flex-start' }}
          >
            Update logo in Scouting Ops Hub
            <ArrowSquareOutIcon size={14} />
          </MuiLink>
        </Stack>
      </Stack>
    </Box>
  );
}
